import PropTypes from 'prop-types';

import { Table, TableBody, TableHead, TableHeader, TableRow } from '@ctct/ui-react';

import InvitationRow from './InvitationRow';
import UserRow from './UserRow';
import displayLastUpdateTime from '../../../constants/flags';

const propTypes = {
  t: PropTypes.func.isRequired,
  onRefreshUsers: PropTypes.func.isRequired,
  onRefreshInvites: PropTypes.func.isRequired,
  setAlertData: PropTypes.func.isRequired,
  invitations: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  users: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  allowedUpgrade: PropTypes.bool.isRequired,
  isPro: PropTypes.bool.isRequired,
  isLoggedInUserSiteOwner: PropTypes.bool.isRequired,
};

const UserTable = ({
  t,
  invitations,
  users,
  onRefreshUsers,
  onRefreshInvites,
  setAlertData,
  allowedUpgrade,
  isPro,
  isLoggedInUserSiteOwner,
}) => {
  return (
    <Table data-qe-id="users-table">
      <TableHead>
        <TableRow>
          <TableHeader>{t('users.table.name')}</TableHeader>
          <TableHeader>{t('users.table.email')}</TableHeader>
          <TableHeader>{t('users.table.status')}</TableHeader>
          {!isPro && <TableHeader>{t('users.table.user_role')}</TableHeader>}
          <TableHeader>{t('users.table.last_login')}</TableHeader>
          {displayLastUpdateTime && <TableHeader>{t('users.table.last_update')}</TableHeader>}
          <TableHeader scope="col" columnType="actions" />
        </TableRow>
      </TableHead>
      <TableBody>
        {invitations.map((invitation, index) => (
          // TODO: update status after CSI adds status to invitations
          <InvitationRow
            data-qe-id={`users-invitation${index}`}
            key={invitation.target + invitation.expirationTime}
            t={t}
            status={invitation.inviteStatus || t('users.status.invite_sent')}
            roleId={invitation.roleId}
            invitationType={invitation.invitationType}
            expirationTime={invitation.expirationTime}
            target={invitation.target}
            onRefreshInvites={onRefreshInvites}
            setAlertData={setAlertData}
            isLoggedInUserSiteOwner={isLoggedInUserSiteOwner}
          />
        ))}
        {users.map((user, index) => {
          const { userDetails, userUuid, status, userRoles } = user || {};
          const { firstName, lastName, email, lastUiLoginTime, userLastUpdateTime } = userDetails || {};
          const userName = firstName ? `${firstName} ${lastName}` : lastName;
          const [{ roleId: role }] = userRoles;

          return (
            <UserRow
              key={userUuid}
              userUuid={userUuid}
              name={userName}
              email={email}
              status={status}
              userRowRole={role}
              lastUpdate={userLastUpdateTime}
              lastLogin={lastUiLoginTime}
              t={t}
              data-qe-id={`users-user${index}`}
              onRefreshUsers={onRefreshUsers}
              setAlertData={setAlertData}
              allowedUpgrade={allowedUpgrade}
              isPro={isPro}
              isLoggedInUserSiteOwner={isLoggedInUserSiteOwner}
            />
          );
        })}
      </TableBody>
    </Table>
  );
};

UserTable.propTypes = propTypes;
export default UserTable;
